
import { namespaceName } from "@/store/createStore";
import { ExerciseMutations } from "@/store/modules/exercise/types";
import { defineComponent, ref } from "vue";
import ButtonVue from "../ui/Button.vue";
import RoundPhasesVue from "./RoundPhases.vue";
import WarningNoteVue from "./WarningNote.vue";

let interval: import("@/types/timeout").TimeoutReturn = void 0;
export default defineComponent({
  name: "BreathingExercise-Start",
  components: {
    appButton: ButtonVue,
    appWarningNote: WarningNoteVue,
    appRoundPhases: RoundPhasesVue,
  },

  setup() {
    const countdownTime = process.env.NODE_ENV === "development" ? 0 : 3 + 1;
    const counter = ref(countdownTime);

    return {
      countdownTime,
      counter,
    };
  },

  methods: {
    startExercise() {
      this.counter--;

      interval = setInterval(this.descrease, 1000);
    },

    descrease() {
      if (this.counter > 0) {
        this.counter--;
        return;
      }
      clearInterval(interval);
      interval = void 0;
      this.$store.commit(namespaceName("exercise", ExerciseMutations.Start));
      this.$router.push({
        name: "BreathingExercise-Breathing",
      });
    },
  },

  beforeRouteLeave() {
    if (interval) {
      clearInterval(interval);
      interval = void 0;
    }
  },
});
